<template>
<div id="wechataddpet">

    <div class="TTL-wechat-setting-btn">
        <div class="TTL-switch"><el-switch v-model="param.isshow" inactive-text="是否显示" @click="ChangeShow"/></div>
    </div>

</div>
</template>


<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_WECHAT from '@/Interface/Shop/wechat';
export default {
    props:['value'],
    components: {},
    data() {
        return {
           param: {
               isshow:false,
               uploadimageIndex:'', //获取当前上传图片的序号
           },
        }   
    },

    mounted() {
        var _this=this;
        setTimeout(function() {
            _this.GetWechatAdPet(); //获取新增宠物信息是否显示
        },200);
    },

    methods: {

        //获取新增宠物信息是否显示
        GetWechatAdPet() {
            var obj=document.getElementById("wechataddpet");
            this.$loading.openloading(obj);
            INTERFACE_WECHAT.GET_WECHAT_ADD_PET().then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.isshow=res.data.show ? true : false;
                 console.log(res.data);
            });
        },


        /** 修改是否显示 **/
        ChangeShow() {
            INTERFACE_WECHAT.CHANGE_ADD_PET_SHOW({isshow:this.param.isshow ? 1 : 0}).then((res) => {
                if(res.status > 0) {
                    this.param.isshow ? this.param.isshow=false : this.param.isshow=true;
                    return false; 
                }
                //回调父组件操作
                this.$emit('finish');
                //刷新banner信息列表
                this.GetWechatAdPet(); 
            });
        },

    },

}
</script>
<style lang="scss" Scoped>
.TTL-wechat-setting-btn {display:inline-flex;align-items: center;padding:10px 0;position: relative;width:100%;}
.TTL-wechat-setting-btn .TTL-button {position:absolute;right:0;}
</style>